import React from 'react';
import {FmlxTable} from 'fmlx-common-ui';
import PropTypes from 'prop-types';
import FastModal from '../../components/FastModal';
import withIntl from '../../lib/withIntl';
import FormattedHTMLMessage from '../../components/FormattedHTMLMessage';

function RemoveLabwareModal({showModal, handleClose, data, intl}) {
  const getContent = () => {
    const COLUMNS = [
      {
        Header: 'Plate Name',
        accessor: 'plateName',
        // eslint-disable-next-line react/prop-types, react/no-unstable-nested-components
        Cell: ({value}) => <b>{value}</b>,
        disableSort: true,
        hideSort: true,
        hideFilter: true,
        headerStyle: {width: '40%', fontWeight: 'bold'},
      },
      {
        Header: 'Used in Protocol',
        accessor: 'usedInProtocol',
        disableSort: true,
        hideSort: true,
        hideFilter: true,
        headerStyle: {width: '46%', fontWeight: 'bold'},
      },
    ];

    return (
      <>
        <div style={{marginBottom: 16}}>
          <FormattedHTMLMessage id="labwareManager.modal.removeLabware.text" />
        </div>
        <FmlxTable data={data} columns={COLUMNS} />
      </>
    );
  };

  const getButton = () => [
    {
      className: 'btn-lg',
      style: 'primary',
      handlerClick: () => {
        handleClose();
      },
      text: intl.formatMessage({id: 'labwareManager.modal.removeLabware.firstButton'}),
    },
  ];

  return (
    <FastModal
      show={showModal}
      btnAction={getButton()}
      header={intl.formatMessage({id: 'labwareManager.modal.removeLabware.title'})}
      size="lg"
      closeDisabled
      content={getContent()}
      onClose={handleClose}
      isValid
    />
  );
}

RemoveLabwareModal.propTypes = {
  intl: PropTypes.any,
  showModal: PropTypes.bool,
  handleClose: PropTypes.func,
  data: PropTypes.array,
};

RemoveLabwareModal.defaultProps = {
  intl: {},
  showModal: true,
  handleClose: () => {},
  data: [],
};

export default withIntl(RemoveLabwareModal);
